import styled from 'styled-components';

const TagsContainer = styled.div`
  > div {
    margin: 5px 0;
  }
`;

export default TagsContainer;
